import SchoolExamPeriodRepairAPI from '@/apis/business/teacher/school-exam-period-repair-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,

  state: {
    reOrganizeExamList: [],
    examInfo: {},
    newExamInfo: {},
    isUpdate: false,
    updateStatusExamRepair: null,
    updateStatusExamRepairResponse: null,
    setSchoolExamPeriodRepairs: [], // danh sách bài kiểm tra bù
    openTopicResponses: []
  },

  mutations: {
    setReOrganizeExamList (state, reOrganizeExamList) {
      state.reOrganizeExamList = reOrganizeExamList
    },

    setExamInfo (state, examInfo) {
      state.examInfo = examInfo
    },

    setIsUpdate (state, isUpdate) {
      state.isUpdate = isUpdate
    },

    /**
     * Gán giá trị response sau khi mở, đóng đề
     * @param {*} state
     * @param {*} updateStatusResponse
     */
    setUpdateStatusRepairResponse (state, updateStatusExamRepairResponse) {
      state.updateStatusExamRepairResponse = updateStatusExamRepairResponse
    },

    setUpdateStatusExamRepair (state, updateStatusExamRepair) {
      state.updateStatusExamRepair = updateStatusExamRepair
    },

    addNewRepairPeriod (state, newPeriod) {
      state.reOrganizeExamList.push(newPeriod)
    },
    /**
     * Gán giá trị danh sách bài kiểm tra bù
     */
    setSchoolExamPeriodRepairs (state, schoolExamPeriodRepairs) {
      state.schoolExamPeriodRepairs = schoolExamPeriodRepairs
    },
    /**
     * Gán giá trị response sau khi mở, đóng đề
     * @param {*} state
     * @param {*} openTopicResponses
     */
    setOpenTopicResponses (state, openTopicResponses) {
      state.openTopicResponses = openTopicResponses
    }
  },

  actions: {
    /**
     * @description Lấy danh sách bài KT bù
     * @author lhlong
     */
    async getExamPeriodRepairList (context, params) {
      var res = await SchoolExamPeriodRepairAPI.getAsync('/repair-list', {
        params
      })
      if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
        context.commit('setReOrganizeExamList', res.Data)
      }
      return res.Data
    },

    /**
     * @description Thêm hoặc cập nhật bài kiểm tra bù
     * @author lhlong
     */
    async insertOrUpdateExamRepair (context, params) {
      var res = await SchoolExamPeriodRepairAPI.postAsync('/period', params)

      if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
        context.commit('addNewRepairPeriod', params)
      }
      return res
    },

    /**
     * @description Đóng/mở bài kiểm tra bù
     * @author lhlong
     */
    async updateExamRepairStatus (context, payload) {
      var res = await SchoolExamPeriodRepairAPI.putAsync('exam-status', payload)

      if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
        context.commit('setUpdateStatusRepairResponse', res?.Data)
      }

      return res
    },

    /**
     * @description Xóa bài kiểm tra bù
     * @author lhlong
     */
    async deletePeriodRepair (context, params) {
      var res = await SchoolExamPeriodRepairAPI.deleteAsync(`period-repair?periodRepairID=${params.periodRepairID}&periodID=${params.periodID}`)

      return res
    },

    /**
     * Lấy danh sách bài kiểm tra bù
     * @param {} context
     * @param {*} filterParam
     * @returns
     * @author TTLONG
     */
    getListSchoolExamPeriodRepair (context, filterParam) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodRepairAPI.getAsync('get-school-exam-periods-repair', {
          params: filterParam
        })
          .then((res) => {
            context.commit('setSchoolExamPeriodRepairs', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Cập nhật trạng thái mở đóng đề
     * @author TTLONG
     * @param {*} context
     * @param {*} openTopicsParams
     * @returns
     */
    openTopicsFromCompensatoryTest (context, openTopicsParams) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodRepairAPI.postAsync(
          'open-topics', openTopicsParams
        )
          .then((res) => {
            context.commit('setOpenTopicResponses', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
